import { Components, Theme } from '@mui/material';

import { MuiAutocomplete } from './MuiAutocomplete';
import { MuiAvatar } from './MuiAvatar';
import { MuiButton } from './MuiButton';
import { MuiCard } from './MuiCard';
import { MuiCardContent } from './MuiCardContent';
import { MuiCardHeader } from './MuiCardHeader';
import { MuiCheckbox } from './MuiCheckbox';
import { MuiChip } from './MuiChip';
import { MuiCssBaseline } from './MuiCssBaseline';
import { MuiDialog } from './MuiDialog';
import { MuiFormControlLabel } from './MuiFormControlLabel';
import { MuiIcon } from './MuiIcon';
import { MuiIconButton } from './MuiIconButton';
import { MuiInputAdornment } from './MuiInputAdornment';
import { MuiLink } from './MuiLink';
import { MuiMenuItem } from './MuiMenuItem';
import { MuiPopover } from './MuiPopover';
import { MuiRadio } from './MuiRadio';
import { MuiSelect } from './MuiSelect';
import { MuiSkeleton } from './MuiSkeleton';
import { MuiSwitch } from './MuiSwitch';
import { MuiTab } from './MuiTab';
import { MuiTableSortLabel } from './MuiTableSortLabel';
import { MuiTextField } from './MuiTextField';
import { MuiTooltip } from './MuiTooltip';

declare module '@mui/material/OverridableComponent' {
  export interface CommonProps {
    /* Used in IconButton */
    inverse?: boolean;
    /* Used in Chip */
    flat?: boolean;
    testId?: string;
  }
}

const components: Components<Theme> = {
  MuiAvatar,
  MuiAutocomplete,
  MuiButton,
  MuiCard,
  MuiCardContent,
  MuiCardHeader,
  MuiCheckbox,
  MuiChip,
  MuiCssBaseline,
  MuiDialog,
  MuiFormControlLabel,
  MuiIcon,
  MuiIconButton,
  MuiInputAdornment,
  MuiMenuItem,
  MuiPopover,
  MuiRadio,
  MuiSelect,
  MuiSwitch,
  MuiTableSortLabel,
  MuiTextField,
  MuiSkeleton,
  MuiLink,
  MuiTooltip,
  MuiTab,
};

export default components;
